export default __webpack_public_path__ + "static/icon-components-f1190afbc0ee9fc7ca928a562189284c.svg";